import React from "react";
import AddIconSVG from "../../../components/svg/AddIconSVG";
import UpdateSVG from "../../../components/svg/UpdateSVG";
import CancelSVG from "../../../components/svg/CancelSVG";
import { Form } from "../../../components/controls/useForm";
import FormLabel from "../../../components/HtmlMarkup/FormLabel";
import Controls from "../../../components/controls/control";

export default function FormField({
  isAddForm,
  values,
  handleInputChange,
  handleSubmit,
  handleCancel,
}) {
  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="fieldContainer">
        <FormLabel htmlFor={"title"}>Title</FormLabel>
        <Controls.Input
          id="title"
          name="title"
          autocomplete="title"
          className="login-input rounded-t-md"
          placeholder="Video title"
          value={values.title}
          onChange={handleInputChange}
        />
      </div>

      <div className="fieldContainer">
        <FormLabel htmlFor={"description"}>Description</FormLabel>
        <Controls.TextArea
          id="description"
          name="description"
          className="login-input rounded-t-md"
          placeholder="Video description"
          value={values.description}
          onChange={handleInputChange}
        />
      </div>

      <div className="fieldContainer">
        <FormLabel htmlFor={"url"}>URL</FormLabel>
        <Controls.Input
          id="url"
          name="url"
          autocomplete="url"
          className="login-input rounded-t-md"
          placeholder="Video url"
          type={"url"}
          value={values.url}
          onChange={handleInputChange}
        />
      </div>

      <div className="fieldContainer">
        <FormLabel htmlFor={"views"}>Views</FormLabel>
        <Controls.Input
          id="views"
          name="views"
          autocomplete="views"
          className="login-input rounded-t-md"
          placeholder="Video views"
          type="number"
          value={values.views}
          onChange={handleInputChange}
        />
      </div>

      <div className="fieldContainer">
        <FormLabel htmlFor={"duration"}>Duration</FormLabel>
        <Controls.Input
          id="duration"
          name="duration"
          autocomplete="duration"
          className="login-input rounded-t-md"
          placeholder="Video duration as a seconds"
          type="number"
          value={values.duration}
          onChange={handleInputChange}
        />
      </div>

      {isAddForm && (
        <div className="fieldContainer">
          <FormLabel htmlFor={"createdAt"}>CreatedAt</FormLabel>
          <Controls.Input
            id="createdAt"
            name="createdAt"
            autocomplete="createdAt"
            className="login-input rounded-t-md"
            placeholder="Video createdAt"
            type="datetime-local"
            step={1}
            value={values.createdAt}
            onChange={handleInputChange}
          />
        </div>
      )}

      <div className="text-right ">
        <Controls.Button
          text={<span className="ml-2">{isAddForm ? "Add" : "Edit"}</span>}
          type="submit"
          startIcon={isAddForm ? <AddIconSVG /> : <UpdateSVG />}
          className="mt-24 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        />
        <Controls.Button
          onClick={handleCancel}
          text={<span className="ml-2">Cancel</span>}
          startIcon={<CancelSVG />}
          className="mt-4 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        />
      </div>
    </Form>
  );
}
